import { PdpDataProvider } from "@/components/pdp/PdpDataContext";
import MegaHeaderV3 from "@/components/home/MegaHeaderV3";
import RiversolFooter from "@/components/pdp/RiversolFooter";
import { EYE_REPAIR_V31 } from "@/data/eyeRepairV31";
import HomeHero from "@/components/home/HomeHero";
import ShopBySkinTypeV4 from "@/components/home/ShopBySkinTypeV4";
import PromoSpotlightV4 from "@/components/home/PromoSpotlightV4";
import ProductsWeLoveV4 from "@/components/home/ProductsWeLoveV4";
import UniqueIngredientV4 from "@/components/home/UniqueIngredientV4";
import YearsBandV4 from "@/components/home/YearsBandV4";
import SkinAnalyzerBandV4 from "@/components/home/SkinAnalyzerBandV4";
import ExpertGuidanceV4 from "@/components/home/ExpertGuidanceV4";
import RiversolInActionHome from "@/components/home/RiversolInActionHome";
import PressStrip from "@/components/home/PressStrip";
import ReviewsGridV4 from "@/components/home/ReviewsGridV4";

// HP4 — a fourth homepage direction built from a rough client mockup. Reuses
// HP2's header, footer, hero and styling tokens (via the `.home-scope hp2`
// scope → dark #003D4C). The mockup blocks are draft compositions; the video,
// press and testimonial sections are pulled in from HP2 as-is. Nothing on
// HP1/HP2/HP3 or the PDPs is touched.
export default function Hp4() {
  return (
    <PdpDataProvider data={EYE_REPAIR_V31}>
      <div className="home-scope hp2 hp4">
        <MegaHeaderV3 />
        <main data-testid="home-page-v4">
          <HomeHero />
          <ShopBySkinTypeV4 />
          <PromoSpotlightV4 />
          <ProductsWeLoveV4 />
          <UniqueIngredientV4 />
          <YearsBandV4 />
          <SkinAnalyzerBandV4 />
          <ExpertGuidanceV4 />
          <RiversolInActionHome />
          <PressStrip />
          <ReviewsGridV4 />
        </main>
        <RiversolFooter dark />
      </div>
    </PdpDataProvider>
  );
}
